import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    popupRoot: {
        width: 'auto',
        height: 'auto',
    },
    popupWithKeyboard: {
        bottom: '50vh',
    },
    popupWithoutKeyboard: {
        bottom: 0,
    },

    header: {
        display: "flex",
        justifyContent: 'space-between',
        alignItems: 'center',
    },

    renamepopupheading: {
        color: theme.palette.primary.text,
        opacity: '100%',
        fontWeight: '500',
        margin: '16px',
        display: 'flex',
    },

    errorMessage: {
        margin: '-12.8px 16px 16px',
        color: 'red',
        fontSize: '12.8px',
    },

    inputRootCustom: {
        margin: '16px 2px !important',
        '& .MuiInputBase-input': {
            textAlign: 'center',
            fontSize: '16px',
            letterSpacing: '1px',
            padding: '10px 16px',
            border: `1px solid ${theme.palette.tertiary.provisionBordercolor} !important`,
            borderRadius: '5px',
            backgroundColor: 'transparent',
            color: `${theme.palette.tertiary.liveStatusTitle} !important`,
        },
        '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:before': {
            borderBottom: 'none !important',
        },
        '& .MuiInputBase-root': {
            padding: 0,
        },
    },

    customHeader: {
        fontSize: '16px !important',
        fontWeight: '500',
        margin: '16px',
        color: theme.palette.primary.text,
    },

    descriptionText: {
        fontSize: '12px !important',
        color: theme.palette.primary.text,
        margin: '12px',
        opacity: '70%',
    },

    actionGroup: {
        display: 'flex',
        flexDirection: 'row',
        padding: '0 16px 16px',
    },

    cancelButton: {
        flex: 1,
        borderRadius: '8px',
        marginRight: '8px',
        padding: '12.8px',
        color: theme.palette.tertiary.commonButtonBackground,
        border: `1px solid ${theme.palette.tertiary.commonButtonBackground}`,
        backgroundColor: 'transparent',
        textTransform: 'none',
        fontWeight: '500',
    },

    confirmButton: {
        flex: 1,
        borderRadius: '8px',
        marginLeft: '8px',
        padding: '12.8px',
        color: '#FFFFFF',
        backgroundColor: `${theme.palette.tertiary.commonButtonBackground} !important`,
        textTransform: 'none',
        fontWeight: '500',
        '&:disabled': {
            backgroundColor: '#cccccc',
            color: '#FFFFFF',
        },
        '&:active': {
            backgroundColor: theme.palette.tertiary.commonButtonBackground,
        },
    },
    dividerBorderColor: {
        backgroundColor: `${theme.palette.tertiary.dividerBorderColor} !important`,
    },

    root: {
        margin: '16px',
        display: 'flex',
        '& input[type=text]': {
            borderBottom: `2px solid ${theme.palette.tertiary.provisionBordercolor} !important`,
            color: `${theme.palette.tertiary.liveStatusTitle} !important`,
            caretColor: `${theme.palette.tertiary.provisionBordercolor} !important`,
        },
        '& input[type=text]:hover ': {
            borderBottom: `2px solid ${theme.palette.tertiary.provisionBordercolor} !important`,
            color: `${theme.palette.tertiary.liveStatusTitle} !important`,
            caretColor: `${theme.palette.tertiary.provisionBordercolor} !important`,
        },
        '& .MuiInput-underline:before': {
            borderBottom: `2px solid ${theme.palette.tertiary.provisionBordercolor} !important`,
            color: `${theme.palette.tertiary.liveStatusTitle} !important`,
            caretColor: `${theme.palette.tertiary.provisionBordercolor} !important`,
        },
        '& .MuiInput-underline:after': {
            borderBottom: `2px solid ${theme.palette.tertiary.provisionBordercolor} !important`,
            color: `${theme.palette.tertiary.liveStatusTitle} !important`,
            caretColor: `${theme.palette.tertiary.provisionBordercolor} !important`,
        },
    },

    renamewifitextfield: {
        margin: '16px',
    },

    closeIcon: {
        fontSize: '20px',
        color: `${theme.palette.tertiary.closeIconColor} !important`,
    },
}));

export { useStyles }

export const ActionItem = styled('div')({
    width: '100%',
    border: 'solid 1px',
    borderColor: '6F6F6F',
    display: 'flex',
    textAlign: 'center',
    borderStyle: 'groove none none none',
    '&>div:nth-child(1)': {
        flex: 0.5,
        color: '#6F6F6F',
        fontWeight: '400',
        fontFamily: 'Visuelt',
        border: 'solid 1px',
        borderStyle: 'none groove none none',
        padding: '16px',
    },
    '&>div:nth-child(2)': {
        flex: 0.5,
        color: '#01b5de',
        fontWeight: '500',
        fontFamily: 'Visuelt',
        padding: '16px',
    },
});
